/* Mutual Optical — localStorage wishlist (no app). Toggles [data-mo-wish] hearts, keeps header count, powers the favorites page. */
(function () {
  var KEY = 'mo_wishlist';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} updateCount(); }
  function has(h) { return get().indexOf(h) > -1; }
  function toggle(h) { var a = get(); var i = a.indexOf(h); if (i > -1) { a.splice(i, 1); } else { a.unshift(h); } save(a); return i === -1; }

  function updateCount() {
    var n = get().length;
    var els = document.querySelectorAll('[data-mo-wish-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].style.display = n > 0 ? '' : 'none';
    }
  }

  function syncButtons(root) {
    var btns = (root || document).querySelectorAll('[data-mo-wish]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', has(btns[i].getAttribute('data-handle')) ? 'true' : 'false');
    }
  }

  // Capture phase: intercept before the card's full-card overlay link can navigate.
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mo-wish]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var h = b.getAttribute('data-handle');
    if (!h) return;
    var added = toggle(h);
    b.setAttribute('aria-pressed', added ? 'true' : 'false');
    document.dispatchEvent(new CustomEvent('mo:wishlist:change', { detail: { handle: h, added: added } }));
  }, true);

  window.MOWishlist = { get: get, has: has, toggle: toggle, remove: function (h) { var a = get(); var i = a.indexOf(h); if (i > -1) { a.splice(i, 1); save(a); } } };

  function init() { syncButtons(); updateCount(); }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

/* Expand the Color filter by default on collection/search (match reference sidebar). */
(function () {
  function openColor() {
    var ds = document.querySelectorAll('.facets-vertical details');
    for (var i = 0; i < ds.length; i++) {
      var s = ds[i].querySelector('summary');
      if (s && /colou?r/i.test(s.textContent)) ds[i].open = true;
    }
  }
  if (document.readyState !== 'loading') openColor(); else document.addEventListener('DOMContentLoaded', openColor);
})();

/* Sidebar CLEAR ALL link (re-applies after facet AJAX re-renders). */
(function () {
  function ensure() {
    var head = document.querySelector('.facets-vertical .facets__heading--vertical');
    if (head && !head.querySelector('.mo-clearall')) {
      var a = document.createElement('a');
      a.className = 'mo-clearall';
      a.href = location.pathname;
      a.textContent = 'Clear All';
      head.appendChild(a);
    }
  }
  function boot() {
    if (!document.querySelector('.facets-vertical')) return;
    ensure();
    var mo = new MutationObserver(function () { ensure(); });
    var container = document.getElementById('ProductGridContainer') || document.body;
    mo.observe(container.parentNode || document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
